import React, { useMemo } from 'react'

import Flag from '@/legacy-src/components/Flag'
import useTherapists from '@/legacy-src/hooks/useTherapists'
import { getLocalisedLanguageName } from '@/legacy-src/utilities/i18n'

import Filter from './Filter'
import { FILTER_LANGUAGE_SLUG } from './filters.constants'

const FilterLanguage: React.FC = () => {
  const { therapists } = useTherapists('visible')

  const therapistLanguages = useMemo(() => {
    const languages: string[] = []
    therapists?.forEach((therapist) => {
      therapist.languages.forEach((language) => {
        if (!languages.includes(language)) {
          languages.push(language)
        }
      })
    })
    return languages
  }, [therapists])

  if (!therapists || (therapists && therapists.length === 0)) return null

  const options = therapistLanguages.map((language) => ({
    label: (
      <div className="flex items-center">
        <Flag languageCode={language} /> {getLocalisedLanguageName(language)}
      </div>
    ),
    value: language,
  }))

  return <Filter slug={FILTER_LANGUAGE_SLUG} options={options} />
}

export default FilterLanguage
